import { getAllValuesFromUrlSearchParams } from 'portaltransparencia-common/libs/URLUtils';
import NumberFormatter from 'portaltransparencia-common/components/NumberFormatter.react.js';
import Panel from 'portaltransparencia-common/components/Panel.react.js';
import SearchPagination from 'portaltransparencia-common/components/SearchPagination.react.js';
import TableActions from 'portaltransparencia-common/components/TableActions.react.js';
import TableHeader from 'portaltransparencia-common/components/TableHeader.react';
import TableHeaderItem from 'portaltransparencia-common/components/TableHeaderItem.react';
import {
  addFilterUrl,
  addPagination
} from 'portaltransparencia-common/libs/AddFilter.js';
import PropTypes from 'prop-types';
import React from 'react';
import Component from 'react-pure-render/component';
import { connect } from 'react-redux';
import PageHeader from '../components/PageHeader.react.js';
import * as actions from './Actions.js';
import { Map } from 'immutable';

export class FormRenunciaReceitaDetalhe extends Component {
  static propTypes = {
    page: PropTypes.object.isRequired,
    findRenunciaReceitaDetalhes: PropTypes.func.isRequired,
    filtros: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired
  };

  componentDidMount() {
    this.carregarRenunciaReceitaDetalhes();
  }

  carregarRenunciaReceitaDetalhes = () => {
    const { page } = this.props;
    const initialPage = page.set('number', 0);

    this.searchWithPage(initialPage);
  };

  montarFiltro = function (page) {
    const { filtros, location } = this.props;
    const params = getAllValuesFromUrlSearchParams(location);

    let filter = `entidade=${params.entidade}&exercicio=${params.exercicio}&descTipoTributo=${params.descTipoTributo}`;

    if (params.descTipoModalidade) {
      filter = addFilterUrl(
        filter,
        `descTipoModalidade=${params.descTipoModalidade}`
      );
    }

    if (filtros.get('dataInicio')) {
      filter = addFilterUrl(filter, `dataInicio=${filtros.get('dataInicio')}`);
    }

    if (filtros.get('dataFim')) {
      filter = addFilterUrl(filter, `dataFim=${filtros.get('dataFim')}`);
    }

    if (filtros.get('tipoOperacao')) {
      filter = addFilterUrl(
        filter,
        `idTipoOperacaoReceita=${filtros.get('tipoOperacao')}`
      );
    }

    if (filtros.get('receitaSelecionada')) {
      const receitaMap = filtros.get('receitaSelecionada');
      const receita = receitaMap.get('receita');
      filter = addFilterUrl(filter, `receita=${encodeURIComponent(receita)}`);
    }

    return addPagination(page, filter);
  };

  searchWithPage = page => {
    const { findRenunciaReceitaDetalhes } = this.props;
    findRenunciaReceitaDetalhes(this.montarFiltro(page));
  };

  renderRenunciaReceitaDetalhe = data => {
    return (
      <TableActions ref="row" key={data.get('lancamento')} data={data}>
        <td>{data.get('receita')}</td>
        <td>{data.get('descTipoOperacaoReceita')}</td>
        <td>{data.get('descricao')}</td>
        <td className="right">
          <NumberFormatter value={data.get('valor')} />
        </td>
      </TableActions>
    );
  };

  render() {
    const { page, location } = this.props;
    const params = getAllValuesFromUrlSearchParams(location);
    const textoDetalhe = `Renúncia de Receita - ${
      params.descTipoTributo || ''
    }${params.descTipoModalidade ? ` / ${params.descTipoModalidade}` : ''}`;

    return (
      <section>
        <PageHeader location={location} textoDetalhe={textoDetalhe} />

        {page && page.get('content') && (
          <Panel
            title="Detalhes da Renúncia de Receita"
            isForm
            tableResponsive
            expansible={false}
          >
            <div className="panel-table-outer">
              <table className="panel-table striped fancy">
                <TableHeader
                  empty={page.get('content').isEmpty()}
                  text="Não foram encontrados registros."
                >
                  <tr>
                    <TableHeaderItem
                      field="receita"
                      label="Receita"
                      page={page}
                      searchWithPage={this.searchWithPage}
                    />
                    <TableHeaderItem
                      field="descTipoOperacaoReceita"
                      label="Tipo de Operação"
                      page={page}
                      searchWithPage={this.searchWithPage}
                    />
                    <TableHeaderItem
                      field="descricao"
                      label="Descrição"
                      page={page}
                      searchWithPage={this.searchWithPage}
                    />
                    <TableHeaderItem
                      field="valor"
                      label="Valor"
                      page={page}
                      searchWithPage={this.searchWithPage}
                      alignment="right"
                    />
                    <th />
                  </tr>
                </TableHeader>
                <tbody>
                  {page.get('content').map(this.renderRenunciaReceitaDetalhe)}
                </tbody>
              </table>
            </div>

            <SearchPagination
              page={page}
              searchWithPage={this.searchWithPage}
            />
          </Panel>
        )}
      </section>
    );
  }
}

function mapStateToProps(state) {
  return {
    filtros: state.crud.getIn(
      ['filtroRenunciasDetalhe', 'currentRecord'],
      Map({})
    ),
    page: state.contabRenunciaReceitas.get('renunciasReceitaDetalhe')
  };
}

const allActions = {
  ...actions
};

export default connect(mapStateToProps, allActions)(FormRenunciaReceitaDetalhe);
